import { render, staticRenderFns } from "./pro-list.vue?vue&type=template&id=10b04284&scoped=true"
import script from "./pro-list.vue?vue&type=script&lang=js"
export * from "./pro-list.vue?vue&type=script&lang=js"
import style0 from "./pro-list.vue?vue&type=style&index=0&id=10b04284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b04284",
  null
  
)

export default component.exports